import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import FileAttachment from '../file-attachment/FileAttachment';
import Iconify from '../iconify';

InvoiceFileAttachmentRow.propTypes = {
  file: PropTypes.object,
  fileName: PropTypes.string,
  onOpen: PropTypes.func,
  onDownload: PropTypes.func,
  showDownload: PropTypes.bool,
  compact: PropTypes.bool,
  additionalMenuItems: PropTypes.func,
  menuTriggerRenderer: PropTypes.func,
  backgroundColor: PropTypes.string,
};

export default function InvoiceFileAttachmentRow({
  file,
  fileName,
  onOpen,
  onDownload,
  showDownload = true,
  compact = false,
  additionalMenuItems,
  menuTriggerRenderer,
  backgroundColor = 'rgba(193, 201, 208, 0.2)',
}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const hasMenu = !!onDownload || !!additionalMenuItems;

  const openMenu = (e) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
  };

  const closeMenu = () => setMenuAnchorEl(null);

  const defaultMenuTrigger = (
    <IconButton size={compact ? 'small' : 'medium'} onClick={openMenu}>
      <Iconify icon="mdi:dots-vertical" width={compact ? 16 : 20} height={compact ? 16 : 20} />
    </IconButton>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: '5px',
        backgroundColor,
      }}
    >
      <FileAttachment
        file={file}
        fileName={fileName}
        canDeleteFile={false}
        handleDeleteFile={() => {}}
        handleClickAttachment={onOpen}
        compact={compact}
        backgroundColor={'transparent'}
      />

      {hasMenu && (
        <>
          {menuTriggerRenderer ? menuTriggerRenderer(openMenu) : defaultMenuTrigger}
          <Menu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={closeMenu}>
            {showDownload && !!onDownload && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  onDownload(closeMenu);
                }}
              >
                <Iconify icon="mdi:download" sx={{ mr: 0.5 }} />
                <Typography sx={{ display: 'inline-block' }}>Download</Typography>
              </MenuItem>
            )}
            {additionalMenuItems?.(closeMenu)}
          </Menu>
        </>
      )}
    </Box>
  );
}
